

































































































































































































































































































































































































































































































































































































//=============================================================================
// 利用者請求・領収書 備考編集
//=============================================================================
import Component, { mixins } from "vue-class-component";
import AxiosMixin from "@/mixins/axiosMixin";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import VueRouter from "vue-router";
import { ShowSnackbar } from "@/store/modules/showSnackbar/types";
import { State } from "vuex-class";
import AlphaNumHalfKanaInput from "@/components/common/AlphaNumHalfKanaInput.vue";
import { PulldownItem } from "@/types";

Component.registerHooks(["beforeRouteLeave"]);

//備考情報
interface RemarksInfo {
  inv_com_remark_includ: number;
  inv_com_remark: string;
  inv_remark: string;
  rece_com_remark_includ: number;
  rece_com_remark: string;
  rece_remark: string;
}

//請求金額調整
interface AdjustmentAmount {
  adjust_title1: string;
  adjust_amount1: number | null;
  adjust_title2: string;
  adjust_amount2: number | null;
}

//利用者支払情報
interface PaymentMethod {
  patient_pay_kbn: number; //支払方法\n1:集金\n2:振込\n3:引落
  patient_withdrawal_st_kbn: number; //引落開始設定\n1:開始する\n2:開始しない
  patient_financial_institution_kbn: number; //銀行選択\n1:ゆうちょ\n2:ゆうちょ銀行以外の金融機関
  patient_institution_no: string; //振替金融機関コード
  patient_institution_name: string; //振替金融機関名
  patient_branch_no: string; //支店コード
  patient_branch_name: string; //支店名
  patient_deposit_kbn: number; //預金種目\n1:普通\n2:当座
  patient_account_no: string; //口座番号
  patient_depositor: string; //預金者名
}

@Component({
  components: {
    AlphaNumHalfKanaInput,
    LoadingDialog
  }
})
export default class UserInvoiceEdit extends mixins(AxiosMixin) {
  //=================================================================
  // プロパティ
  //=================================================================
  @State("showsnackbar") snack!: ShowSnackbar;

  //備考情報
  private remarksInfo: RemarksInfo = {
    inv_com_remark_includ: 0,
    inv_com_remark: "",
    inv_remark: "",
    rece_com_remark_includ: 0,
    rece_com_remark: "",
    rece_remark: ""
  };

  //請求金額調整
  private adjustmentAmount: AdjustmentAmount = {
    adjust_title1: "",
    adjust_amount1: 0,
    adjust_title2: "",
    adjust_amount2: 0
  };

  //利用者口座情報
  private paymentMethod: PaymentMethod = {
    patient_pay_kbn: 0,
    patient_withdrawal_st_kbn: 2,
    patient_financial_institution_kbn: 0,
    patient_institution_no: "",
    patient_institution_name: "",
    patient_branch_no: "",
    patient_branch_name: "",
    patient_deposit_kbn: 0,
    patient_account_no: "",
    patient_depositor: ""
  };

  private isEdit = false;
  private selectItemTab = 0; //選択中のタブ
  private selectItemTab2 = 0; //選択中の子タブ
  private isTrial = window.is_trial;

  //請求書 共通備考
  get isInvRemarksInc(): boolean {
    return this.remarksInfo.inv_com_remark_includ == 1;
  }
  set isInvRemarksInc(value: boolean) {
    if (value) {
      this.remarksInfo.inv_com_remark_includ = 1;
    } else {
      this.remarksInfo.inv_com_remark_includ = 0;
    }
  }

  //領収書 共通備考
  get isReceRemarksInc(): boolean {
    return this.remarksInfo.rece_com_remark_includ == 1;
  }
  set isReceRemarksInc(value: boolean) {
    if (value) {
      this.remarksInfo.rece_com_remark_includ = 1;
    } else {
      this.remarksInfo.rece_com_remark_includ = 0;
    }
  }

  //必須入力判定
  get isRqurired(): boolean {
    return (
      this.paymentMethod.patient_pay_kbn === 3 &&
      this.paymentMethod.patient_withdrawal_st_kbn === 1
    );
  }
  //ドロップダウン選択設定
  private payKbnList: PulldownItem[] = [
    { text: "未選択", value: 0 },
    { text: "集金", value: 1 },
    { text: "振込", value: 2 },
    { text: "引落", value: 3 }
  ];
  private withdrawalStKbnList: PulldownItem[] = [
    { text: "開始しない", value: 2 },
    { text: "開始する", value: 1 }
  ];
  private financialInstitutionKbnList: PulldownItem[] = [
    { text: "未選択", value: 0 },
    { text: "ゆうちょ銀行", value: 1 },
    { text: "ゆうちょ銀行以外の金融機関", value: 2 }
  ];
  private depositKbnList: PulldownItem[] = [
    { text: "未選択", value: 0 },
    { text: "１：普通", value: 1 },
    { text: "２：当座", value: 2 }
  ];

  //=================================================================
  // メソッド
  //=================================================================
  mounted() {
    this.updateData();
  }

  //画面遷移
  private beforeRouteLeave(to: VueRouter, from: VueRouter, next: Function) {
    if (this.isEdit) {
      if (!confirm("入力した情報が保存されていません。よろしいですか？")) {
        // this.$nextTick(() => {
        //  this.navigationManage();
        // });
        next(false);
        return;
      }
    }
    next();
  }

  //データ取得
  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/userinvoice/get_remarks",
      {
        id: Number(this.$route.params.id),
        patient_id: Number(this.$route.query.patient_id),
        patient_name: String(this.$route.query.patient_name)
      },
      res => {
        this.remarksInfo = res.data.remarks_info;
        this.adjustmentAmount = res.data.adjustment_amount;
        if (this.adjustmentAmount.adjust_amount1 == 0) {
          this.adjustmentAmount.adjust_amount1 = null;
        }
        if (this.adjustmentAmount.adjust_amount2 == 0) {
          this.adjustmentAmount.adjust_amount2 = null;
        }
        this.setPatinetMethod(res.data.payment_method);
      }
    );
  }

  //キャンセル
  private cancel() {
    this.$router.go(-1);
  }

  //保存
  private save() {
    if (!this.isPaymentMethodCheckOK()) {
      return;
    }
    this.adjustmentAmount.adjust_amount1 = Number(
      this.adjustmentAmount.adjust_amount1
    );
    this.adjustmentAmount.adjust_amount2 = Number(
      this.adjustmentAmount.adjust_amount2
    );
    const paymentMethod = this.getParamPaymentMethod();
    this.postJsonCheck(
      window.base_url + "/api/office/userinvoice/save_remarks",
      {
        remarks_info: this.remarksInfo,
        adjustment_amount: this.adjustmentAmount,
        payment_method: paymentMethod,
        patient_id: Number(this.$route.query.patient_id),
        patient_name: String(this.$route.query.patient_name)
      },
      res => {
        this.remarksInfo = res.data.remarks_info;
        this.isEdit = false;
        this.snack.message = "保存しました。";
        this.snack.showSnackbar = true;
        this.cancel();
      }
    );
  }
  //----------------------------------------------------------
  //利用者請求管理
  //----------------------------------------------------------
  private setPatinetMethod(p: PaymentMethod) {
    //支払方法
    this.paymentMethod.patient_pay_kbn = p.patient_pay_kbn;
    //引落開始設定(0は[2:開始しない]にマッピング)
    //*** DBに0か2で登録されているため
    this.paymentMethod.patient_withdrawal_st_kbn =
      p.patient_withdrawal_st_kbn === 0 ? 2 : p.patient_withdrawal_st_kbn;
    //銀行選択
    this.paymentMethod.patient_financial_institution_kbn =
      p.patient_financial_institution_kbn;
    //初期化
    this.paymentMethod.patient_institution_no = "";
    this.paymentMethod.patient_institution_name = "";
    this.paymentMethod.patient_branch_no = "";
    this.paymentMethod.patient_branch_name = "";
    this.paymentMethod.patient_deposit_kbn = 0;
    this.paymentMethod.patient_account_no = "";
    this.paymentMethod.patient_depositor = "";
    switch (this.paymentMethod.patient_financial_institution_kbn) {
      case 1: //ゆうちょ銀行
        // 金融機関コードは「9900」固定  => 固定はやめる(IBR-739対応)
        // 預金種目は「1」固定  => 固定はやめる(IBR-739対応)
        this.paymentMethod.patient_institution_no = p.patient_institution_no;
        this.paymentMethod.patient_deposit_kbn = p.patient_deposit_kbn;
        this.paymentMethod.patient_branch_no = p.patient_branch_no;
        this.paymentMethod.patient_account_no = p.patient_account_no;
        this.paymentMethod.patient_depositor = p.patient_depositor;
        break;
      case 2: //ゆうちょ銀行以外の金融機関
        this.paymentMethod.patient_institution_no = p.patient_institution_no;
        this.paymentMethod.patient_institution_name =
          p.patient_institution_name;
        this.paymentMethod.patient_branch_no = p.patient_branch_no;
        this.paymentMethod.patient_branch_name = p.patient_branch_name;
        this.paymentMethod.patient_deposit_kbn = p.patient_deposit_kbn;
        this.paymentMethod.patient_account_no = p.patient_account_no;
        this.paymentMethod.patient_depositor = p.patient_depositor;
        break;
    }
  }
  private isPaymentMethodCheckOK(): boolean {
    const pat = this.paymentMethod;
    const digit: string[] = [];
    // 桁数チェック
    switch (pat.patient_financial_institution_kbn) {
      case 1: //ゆうちょ銀行
        if (
          pat.patient_branch_no.length !== 0 &&
          pat.patient_branch_no.length !== 5
        ) {
          digit.push("支店コードは5桁で入力してください。");
        }
        if (
          pat.patient_account_no.length !== 0 &&
          pat.patient_account_no.length !== 8
        ) {
          digit.push("口座番号は8桁で入力してください。");
        }
        break;
      case 2: //ゆうちょ銀行以外の金融機関
        if (
          pat.patient_institution_no.length !== 0 &&
          pat.patient_institution_no.length !== 4
        ) {
          digit.push("振替金融機関コードは4桁で入力してください。");
        }
        if (
          pat.patient_branch_no.length !== 0 &&
          pat.patient_branch_no.length !== 3
        ) {
          digit.push("支店コードは3桁で入力してください。");
        }
        if (
          pat.patient_account_no.length !== 0 &&
          pat.patient_account_no.length !== 7
        ) {
          digit.push("口座番号は7桁で入力してください。");
        }
        break;
    }
    // 必須チェック
    const arr: string[] = [];
    // 支払方法が引落、かつ引落開始設定が開始するの場合のみ必須入力のチェックを行う。
    if (pat.patient_pay_kbn === 3 && pat.patient_withdrawal_st_kbn === 1) {
      switch (pat.patient_financial_institution_kbn) {
        case 1: //ゆうちょ銀行
          if (!pat.patient_branch_no) {
            arr.push("支店コード");
          }
          if (!pat.patient_account_no) {
            arr.push("口座番号");
          }
          if (!pat.patient_depositor) {
            arr.push("預金者名");
          }
          break;
        case 2: //ゆうちょ銀行以外の金融機関
          if (!pat.patient_institution_no) {
            arr.push("振替金融機関コード");
          }
          if (!pat.patient_branch_no) {
            arr.push("支店コード");
          }
          if (!pat.patient_deposit_kbn) {
            arr.push("預金種目");
          }
          if (!pat.patient_account_no) {
            arr.push("口座番号");
          }
          if (!pat.patient_depositor) {
            arr.push("預金者名");
          }
          break;
        default:
          //未選択
          arr.push("銀行選択");
          break;
      }
    }
    let message = "";
    digit.forEach(item => {
      message += `${item}\n`;
    });
    arr.forEach((item, idx) => {
      if (idx === 0) {
        message += item;
      } else {
        message = `${message}, ${item}`;
      }
    });
    if (arr.length > 0) {
      message = `${message}は必須です。`;
    }
    if (message) {
      alert(message);
      return false;
    }
    return true;
  }
  private getParamPaymentMethod(): any {
    const param: any = {};
    param.patient_pay_kbn = this.paymentMethod.patient_pay_kbn;
    param.patient_withdrawal_st_kbn = this.paymentMethod.patient_withdrawal_st_kbn;
    param.patient_financial_institution_kbn = this.paymentMethod.patient_financial_institution_kbn;
    switch (this.paymentMethod.patient_financial_institution_kbn) {
      case 1: //ゆうちょ銀行
        // 金融機関コードは「9900」固定 => 固定はやめる(IBR-739対応)
        // 預金種目は「1」固定  => 固定はやめる(IBR-739対応)
        param.institution_no = this.paymentMethod.patient_institution_no;
        param.deposit_kbn = this.paymentMethod.patient_deposit_kbn;
        param.patient_branch_no = this.paymentMethod.patient_branch_no;
        param.patient_account_no = this.paymentMethod.patient_account_no;
        param.patient_depositor = this.paymentMethod.patient_depositor;
        break;
      case 2: //ゆうちょ銀行以外の金融機関
        param.patient_institution_no = this.paymentMethod.patient_institution_no;
        param.patient_institution_name = this.paymentMethod.patient_institution_name;
        param.patient_branch_no = this.paymentMethod.patient_branch_no;
        param.patient_branch_name = this.paymentMethod.patient_branch_name;
        param.patient_deposit_kbn = this.paymentMethod.patient_deposit_kbn;
        param.patient_account_no = this.paymentMethod.patient_account_no;
        param.patient_depositor = this.paymentMethod.patient_depositor;
        break;
    }
    return param;
  }
}
